<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header"><h5>Полезный склад</h5></div>
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <table v-if="Object.keys(records).length" class="table mt-1 table-sm table-hover">
          <thead>
          <tr>
            <th>ID</th>
            <th>Препарат</th>
            <th>Заявок</th>
            <th>На сумму</th>
            <th>Кол.Пр.</th>
            <th>На складе</th>
          </tr>
          </thead>
          <tbody>
          <template v-for="(sD, storeId) in records">
            <tr class="store_title">
              <td colspan="10"><strong>{{ $AllStores[storeId]?.title }}</strong></td>
            </tr>
            <tr v-for="r in getSortedRecords(sD)"
                :class="{'green_line': (storeData?.inStores?.[r.drug_id]?.[3] ?? 0) > (r.total_qty + 10)}">
              <td>{{ r.drug_id }}</td>
              <td>{{ r.title }}</td>
              <td>{{ r.total_orders }}</td>
              <td>{{ r.total_sum }}</td>
              <td>{{ r.total_qty }}</td>
              <td>{{ storeData?.inStores?.[r.drug_id]?.[3] ?? 0 }}</td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";

export default {
  data() {
    return {
      loading: false,
      records: {},
      storeData: {},
    }
  },
  computed: {
    $AllStores() {
      return this.$store.getters['platform/stores']
    },
  },
  created() {
    this.getRecords();
  },
  methods: {
    getSortedRecords(records) {
      return _.orderBy(records, 'total_qty', 'desc');
    },
    async getRecords() {
      this.loading = true;
      const {data} = await api.index('/stores/useful');
      if (data.success) {
        this.storeData = data.storeData;
        const orders = data.records.reduce((acc, r) => {
          if (!acc[r.store_id]) acc[r.store_id] = [];
          acc[r.store_id].push(r);
          return acc;
        }, {})
        data.userRequests.forEach((r) => {
          if (!orders[r.store_id]) orders[r.store_id] = [];
          const index = orders[r.store_id].findIndex((o) => o.drug_id === r.drug_id);
          if (index !== -1) {
            orders[r.store_id][index].total_orders += r.total_orders;
            orders[r.store_id][index].total_sum += (Math.round(orders[r.store_id][index].total_sum / orders[r.store_id][index].total_qty) * r.total_qty);
            orders[r.store_id][index].total_qty += r.total_qty;
          } else {
            orders[r.store_id].push({
              drug_id: r.drug_id,
              total_orders: r.total_orders,
              total_qty: r.total_qty,
              total_sum: 0,
              title: r.drug.title
            })
          }
        })
        this.records = orders;
      } else {
        toastr['warning'](data.message ?? 'Ошибка сервера', 'Ошибка!');
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
.green_line {
  background-color: #effff1;
}

.store_title {
  background-color: #e8eaff;
}
</style>
